<template>
  <main>
    <div class="flex w-full justify-center mt-16 items-center">
      <div
        class="
          max-w-4xl
          auth-shadow
          p-5
          flex-col
          pb-16
          rounded-md
          w-full
          flex
          items-center
          justify-center
        "
      >
        <div class="flex items-center justify-center flex-col mt-12 mb-6">
          <img src="@/assets/images/traction-logo.png" class="w-48" alt="" />
        </div>
        <div class="max-w-xl w-full mt-10 px-6 text-center">
          <img
            class="w-24 mx-auto mb-6"
            src="@/assets/svg/pending.svg"
            alt=""
          />
          <h1 class="text-lg font-medium text-accentDark">
            Thank you for signing up
          </h1>
          <p class="text-sm text-primaryGray mt-4 leading-6">
            Your account has been created and is pending admin approval. You
            will be able to sign in once an administrator approves your
            request.
          </p>
          <p class="text-xs text-primaryGray mt-6">
            Already approved?
            <router-link to="/login" class="text-primaryBlue font-medium"
              >Login</router-link
            >
          </p>
        </div>
      </div>
    </div>
    <p class="text-xs text-gray-600 mx-auto w-1/2 text-center leading-5 my-6">
      Traction Payments Limited is licensed by the Central Bank of Nigeria as a
      Payment Service Provider with PSSP, PTSP, & Super Agent authorisation.
      <br />
      TA Prime Limited is a licensed money lender
    </p>
  </main>
</template>

<script>
export default {
  name: "SignupPending",
};
</script>
